import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useToast } from '@/hooks/use-toast';
import { createRecipient } from '@/lib/forward-api';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface AddRecipientDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onSuccess: () => void;
}

export function AddRecipientDialog({ open, onOpenChange, onSuccess }: AddRecipientDialogProps) {
    const { t } = useTranslation();
    const { toast } = useToast();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        forwardingNumber: ''
    });

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!formData.title || !formData.forwardingNumber) {
            toast({
                title: t('error.title'),
                description: t('forward.validationError'),
                variant: 'destructive'
            });
            return;
        }

        setLoading(true);
        try {
            await createRecipient(formData);
            toast({
                title: t('success.title'),
                description: t('forward.recipientCreated')
            });
            setFormData({ title: '', forwardingNumber: '' });
            onSuccess();
            onOpenChange(false);
        } catch (error) {
            toast({
                title: t('error.title'),
                description: t('forward.recipientCreateError'),
                variant: 'destructive'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{t('forward.addRecipient')}</DialogTitle>
                </DialogHeader>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <Label htmlFor="title">{t('forward.nameYourRecipient')}</Label>
                        <Input
                            id="title"
                            value={formData.title}
                            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                            placeholder="Serviceteam"
                        />
                    </div>
                    <div>
                        <Label htmlFor="phone">{t('forward.setPhoneNumber')}</Label>
                        <Input
                            id="phone"
                            value={formData.forwardingNumber}
                            onChange={(e) => setFormData({ ...formData, forwardingNumber: e.target.value })}
                            placeholder="+496994322031"
                        />
                    </div>
                    <div className="flex justify-end">
                        <Button type="submit" disabled={loading}>
                            {t('forward.addRecipient')}
                        </Button>
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
}
